import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import 'jquery';
import 'popper.js';
import 'bootstrap';
import axios from 'axios';
import './sass/app.scss';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import vueCountryRegionSelect from "vue-country-region-select";
import ToggleButton from 'vue-js-toggle-button';
import Vuelidate from 'vuelidate';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueFilterDateParse);
Vue.use(vueCountryRegionSelect);
Vue.use(ToggleButton);
Vue.use(Vuelidate);


import Toasted from 'vue-toasted';
import i18n from './i18n';
Vue.use(Toasted, {
    position: "top-right",
    theme: "bubble",
    duration: 4000
});
Vue.prototype.$http = axios.create({
  timeout: 120000 // 15 segundos de tiempo de espera
})
Vue.use(VueFilterDateFormat, {
    dayOfWeekNames: [
        'Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves',
        'Viernes', 'Sábado'
    ],
    dayOfWeekNamesShort: [
        'Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sab'
    ],
    monthNames: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ],
    monthNamesShort: [
        'Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun',
        'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'
    ],
    // Timezone offset, in minutes (0 - UTC, 180 - Russia, undefined - current)
    timezone: 0
});

Vue.component('dynamicform-file-upload', require('./components/DynamicForms/FileUpload').default);
Vue.component('dynamicform-input-text', require('./components/DynamicForms/InputText').default);
Vue.component('dynamicform-textarea', require('./components/DynamicForms/Textarea').default);
Vue.component('dynamicform-select', require('./components/DynamicForms/Select').default);

const vueObject = new Vue({
  router,
  store,
  BootstrapVue,
  IconsPlugin,
  VueFilterDateParse,
  VueFilterDateFormat,
  i18n,
  render: h => h(App)
}).$mount('#kuchentime_backend_intranet');

axios.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
      vueObject.$router.push("/logout");
    }
    return error;
});

if (vueObject.$store.getters['authentication/isAuthenticated']) {
    axios.defaults.headers.common.Authorization = 'Bearer ' + vueObject.$store.getters['authentication/accessToken'];
}



// WEBPACK FOOTER //
// ./src/main.js